import {SearchParams} from '@/stores/transactions/OnlinePaymentsStore/models'

export const extractSearchParam = (value: string) => {
    const params = Object.values(SearchParams)

    return params.find((param) => value?.startsWith(param))
}
